module.exports = __webpack_public_path__ + "img/427.b98d99f8.jpg";